// Temporary ignore antd warnings in console.
// Warnings are related to antd 4.x version components and future React versions, we cannot fix antd source code
export const disableAntdFutureVersionWarnings = () => {
  const originalError = console.error;

  console.error = (...args) => {
    if (
      typeof args[0] === 'string' &&
      args[0].includes('Support for defaultProps will be removed from function components in a future major release.')
    ) {
      return;
    }

    originalError(...args);
  };
};
